// src/pages/FeedPage.tsx
import React from 'react';
import FeedList from '../components/FeedList/FeedList';

const FeedPage: React.FC = () => {
  return <FeedList />;
};
export default FeedPage;
